import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ScrollLock from 'react-scrolllock';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import Box from 'components/box';

const Z_INDEX = 9000;

/**
 * Styles
 */

const fillScreen = css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Overlay = styled.div`
  ${fillScreen}
  background: rgba(0, 0, 0, 0.3);
`;

const ModalContainer = styled.div`
  ${fillScreen}
  overflow-x: auto;
  overflow-y: scroll;
  z-index: ${Z_INDEX};
`;

const ModalCard = styled.div`
  position: relative;
  background: white;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(136, 152, 170, 0.1),
    0 15px 35px 0 rgba(49, 49, 93, 0.1), 0 5px 15px 0 rgba(0, 0, 0, 0.13);
  top: 110px;
  margin: ${props => props.theme.space[5]} auto;
  overflow: hidden;
  width: 95%;
  max-width: 250px;
  min-height: 250px;
`;

/**
 * Base component for showing an object with an overlay
 */

class PhotoModal extends Component {
  static propTypes = {
    children: PropTypes.node,
    closeOnEscapeKey: PropTypes.bool,
    onRequestClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    children: null,
    closeOnEscapeKey: true,
  };

  componentDidMount() {
    const { closeOnEscapeKey } = this.props;
    if (closeOnEscapeKey) {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }

  componentWillUnmount() {
    const { closeOnEscapeKey } = this.props;
    if (closeOnEscapeKey) {
      document.removeEventListener('keydown', this.handleKeydown);
    }
  }

  handleKeyDown = (e) => {
    const { onRequestClose } = this.props;
    if (e.keyCode === 27) {
      onRequestClose();
    }
  };

  handleOverlayClick = () => {
    const { onRequestClose } = this.props;
    onRequestClose();
  };

  render() {
    const { children } = this.props;

    return ReactDOM.createPortal(
      <div>
        <ScrollLock />
        <ModalContainer>
          <Overlay onClick={this.handleOverlayClick} />
          <ModalCard>
            <Box padding={5}>{children}</Box>
          </ModalCard>
        </ModalContainer>
      </div>,
      document.getElementById('root'),
    );
  }
}

/**
 * Exports
 */

export default PhotoModal;
